import type { ContentType } from "../api/types";
import { TYPE_LABELS } from "../lib/format";

/** Small colour-coded label for a content type. */
export function TypeChip({ type }: { type: ContentType }) {
  return (
    <span className="type-chip" data-kind={type}>
      {TYPE_LABELS[type]}
    </span>
  );
}
